import React, { createContext, useContext } from 'react';

import { AuthStatus } from '@pass-frontend/data-access/common/edge';

import { useCurrentState } from './use-current-state';

interface AuthContextValue {
  authStatus: AuthStatus;
  isAuthResolved: boolean;
  isUserAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextValue>({
  authStatus: AuthStatus.unknown,
  isAuthResolved: false,
  isUserAuthenticated: false,
});

export const AuthProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { currentState, loading, isUserAuthenticated } = useCurrentState();
  const authStatus = currentState?.authStatus ?? AuthStatus.unknown;
  const isAuthResolved = !loading && authStatus !== AuthStatus.unknown;

  return (
    <AuthContext.Provider
      value={{ authStatus, isAuthResolved, isUserAuthenticated }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
